import { useDocumentTitle } from '~src/hooks/useDocumentTitle';
import styles from './index.module.less';
import React from 'react';

const imgList = [
    "https://resources-cn.miotech.com/static/mp2c/images/mine/qa.png"
];

const Question = () => {
    useDocumentTitle('常见问题');
    return <div className={styles.container}>
        {imgList.map((url) => (
            <img src={url} key={url} />
        ))}
    </div>
}

export default Question